<template>
  <UtilTileBase :bordered="false" centered>
    <template #icon>
      <UtilPlaceholder class="rounded-full w-24 h-24 mr-3" />
    </template>

    <template #body>
      <UtilPlaceholder class="h-5 mb-1 w-5/12" />
      <UtilPlaceholder class="h-5 mb-1 w-8/12" />
      <UtilPlaceholder class="h-4 w-4/12" />
    </template>
  </UtilTileBase>
</template>

<script>
import UtilPlaceholder from '@/components/utils/placeholders/UtilPlaceholder'
import UtilTileBase from '@/components/utils/UtilTileBase'

export default {
  name: 'UtilPlaceholderUac',
  components: {
    UtilPlaceholder,
    UtilTileBase
  }
}
</script>
